import * as React from "react";

import { FormGroup, NumericInput } from "@blueprintjs/core";
import { WithTranslation, withTranslation } from "react-i18next";
import { IOrderLineItem } from "~/graphql/queries/order/orderByName";
import styled from "~/styled";
import { INexusRMAOrderItem } from "./NexusRMAProductSelector";

interface IProps {
  orderLineItem: IOrderLineItem;
  rmaOrderItem: INexusRMAOrderItem;
  onQuantityChange: (quantity: number) => void;
}

const Wrapper = styled.div`
  display: grid;
  grid-template-areas: "image product-title . quantity";
  grid-auto-columns: auto 1fr auto;
  align-items: center;
  gap: 12px;

  margin: 12px 0;
`;

const ProductTitle = styled.div`
  grid-area: product-title;
`;
const Quantity = styled.div`
  grid-area: quantity;
`;

const Image = styled.div`
  grid-area: image;
  max-width: 100px;
`;

class NexusRMAOrderItem extends React.Component<IProps & WithTranslation> {
  public render() {
    const { t, orderLineItem, rmaOrderItem } = this.props;

    const {
      quantity,
      shopProduct: { shopifyProduct }
    } = orderLineItem;

    const { title, productImages } = shopifyProduct;

    return (
      <Wrapper>
        <Image>
          <img style={{ width: "100%" }} src={productImages[0].src} alt="" />
        </Image>
        <ProductTitle>{title}</ProductTitle>
        <Quantity>
          <FormGroup
            label={t("order.productSelector.numberRuturns")}
            helperText={t("order.productSelector.maximum", {
              quantity
            })}
          >
            <NumericInput
              min={0}
              max={quantity}
              required={true}
              value={rmaOrderItem.quantity}
              onValueChange={this.handleQuantityChange}
            />
          </FormGroup>
        </Quantity>
      </Wrapper>
    );
  }

  public handleQuantityChange = (value: number) =>
    this.props.onQuantityChange(value);
}

export default withTranslation("rmaForm")(NexusRMAOrderItem);



// WEBPACK FOOTER //
// ./src/components/RMAForm/NexusRMAOrderItem.tsx